import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./Page404.css";

export default function PageNotFound() {
  return (
    <>
      <Helmet>
        <title>404 Page Not Found</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <section className="page-error-section section-padding fix section-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="gt-error-items">
                <div
                  className="gt-error-image "
                >
                  <img src="../images/404.png" alt="img" />
                </div>
                <h2 >
                  OPPS! This Page is Not Found
                </h2>
                <p >
                  The page requested could not be found. This could be a
                  spelling error in the URL or a removed page.
                </p>
                <Link
                  to="/"
                  className="Homebtn"
                >
                  BACK TO HOME
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
